import CONFIG from '../config/config';
import { MeetingType } from './meetingTypeToTranslationKey';

export const isReminderEnabledForMeetingType = (meetingType: MeetingType | string): boolean => {
  return CONFIG.MEETINGS.REMINDER_ENABLED_TYPES.includes(meetingType as MeetingType);
};

export const getReminderEnabledMeetingTypes = (): MeetingType[] => {
  return CONFIG.MEETINGS.REMINDER_ENABLED_TYPES as MeetingType[];
};

export const shouldShowReminderCheckbox = (meetingType: MeetingType | string): boolean => {
  return isReminderEnabledForMeetingType(meetingType);
};
